export default __webpack_public_path__ + "static/media/Arrow_2.5003f6b2.svg";